import React, { useState } from 'react';

import queryString from 'query-string';

import { getVersion } from 'utils/version';

import { Container } from './styles';

const version = getVersion();

const queryParams = queryString.parse(window.location.search) as { showVersion?: string };

const Version = () => {
  const [show, setShow] = useState(queryParams.showVersion === null);

  if (!show) return null;

  return (
    <Container onClick={() => setShow(false)}>
      <table>
        <tbody>
          <tr>
            <td>{version.tag ? 'Tag' : 'Branch'}:</td>
            <td>{version.tag || version.branch}</td>
          </tr>
          <tr>
            <td>SHA:</td>
            <td>{version.sha}</td>
          </tr>
          <tr>
            <td>Time:</td>
            <td>{version.date.toLocaleString()}</td>
          </tr>
        </tbody>
      </table>
    </Container>
  );
};

export default Version;
